import axios from "axios";

const raw = process.env.REACT_APP_BACKEND_URL;
const isRelative = raw === "__relative__";
const BACKEND_URL = isRelative ? "" : (raw || `${window.location.protocol}//${window.location.hostname}:8000`);
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
